<template>
    <section class="flex flex-col items-stretch mb-4 px-4 md:px-8 text-zinc-900 dark:text-zinc-100">
        <div class="flex flex-wrap justify-center gap-4 w-full">
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="text-left" for="year">Año</label>
                <Dropdown id="year" v-model="selectedYear" :options="years" optionLabel="name" placeholder="Selecciona un año"
                class="w-full" :disabled="formDisabled"/>
            </div>
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="text-left" for="report">Tipo</label>
                <Dropdown id="report" v-model="selectedReport" :options="reports" optionLabel="name" placeholder="Selecciona un tipo"
                class="w-full" :disabled="formDisabled"/>
            </div>
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="text-left" for="company">Empresa</label>
                <Dropdown id="company" v-model="selectedCompany" :options="companies" optionLabel="name" placeholder="Selecciona una empresa"
                class="w-full" @change="companyChange" :disabled="formDisabled"/>
            </div>
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="text-left" for="branch">Sucursal</label>
                <Dropdown id="branch" v-model="selectedBranch" :options="selectedCompany.branches" optionLabel="name" placeholder="Selecciona una sucursal"
                class="w-full" :disabled="formDisabled" filter/>
            </div>
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="opacity-0" for="show-btn">Acción</label>
                <Button id="show-btn" label="Mostrar" @click="fillTable" :disabled="buttonDisabled"></Button>
            </div>
        </div>
    </section>

    <section class="grid justify-center text-zinc-900 dark:text-zinc-100">
        <h1>{{title}}</h1>
        <div class="card overflow-auto px-4 md:px-12">
            <div class="flex items-center ml-2" v-show="accounts.data?.length > 0">
                <h2>Iguala Mensual</h2>
            </div>
            <div class="flex flex-wrap justify-between items-center gap-4 mb-4">
                <div class="flex flex-wrap gap-4" v-show="accounts.levels?.length > 0">
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-green-500 rounded"></div>
                        <span>{{ displayLevels.accounts[0] }}</span>
                    </div>
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-orange-400 rounded"></div>
                        <span>{{ displayLevels.accounts[1] }}</span>
                    </div>
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-red-500 rounded"></div>
                        <span>{{ displayLevels.accounts[2] }}</span>
                    </div>
                </div>

                <div class="flex gap-4 items-end flex-wrap">
                    <!-- IVA Dropdown -->
                    <div class="bg-zinc-200 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100 rounded-lg px-4 py-2 flex flex-wrap items-center gap-2 shadow"
                        v-show="accounts.data?.length > 0 || extras.data?.length > 0">
                        <span class="text-sm font-semibold">IVA:</span>
                        <Dropdown v-model="ivaOption" :options="ivaOptions" optionLabel="label" optionValue="value"
                            class="w-36" @change="onIvaChange"/>
                    </div>

                    <!-- Sort By Panel -->
                    <div class="bg-zinc-200 text-zinc-900 dark:bg-zinc-800 dark:text-zinc-100 rounded-lg px-4 py-2 flex flex-wrap items-end shadow"
                        v-show="showSortPanel && (accounts.data?.length > 0 || extras.data?.length > 0)">
                        <span class="text-sm mb-2 font-semibold self-center px-2">Ordenar por:</span>
                        <div class="flex items-center gap-2">
                            <Button icon="pi pi-palette" text rounded value="color" class="order-table-btn"
                            @click="sortTables('color')" v-tooltip.bottom="'Color'"/>
                            <Button icon="pi pi-money-bill" text rounded value="total" class="order-table-btn"
                            @click="sortTables('total')" v-tooltip.bottom="'Total'"/>
                            <Button icon="pi pi-sort-alpha-down" text rounded value="name" class="order-table-btn"
                            @click="sortTables('name')" v-tooltip.bottom="'Nombre cliente'"/>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Table 1 -->
            <DataTable
                :value="displayAccounts"
                stripedRows
                showGridlines
                tableStyle="min-width: 30rem"
                class="min-w-full accounts-table"
                scrollable
                scrollHeight="525px"
                v-show="accounts.data?.length > 0">
                <Column field="client" header="Cliente">
                    <template #body="{data}">
                        <span
                            :class="{'green-cell': data.level === 0,
                                'orange-cell': data.level === 1,
                                'red-cell': data.level === 2}">
                            {{ data.client }}
                        </span>
                    </template>
                </Column>
                <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header">
                    <template #body="{data, field}">
                        <span>
                            {{ data[field] }}
                        </span>
                    </template>
                </Column>
            </DataTable>

            <div class="flex items-center ml-2 mt-4" v-show="extras.data?.length > 0">
                <h2>Servicios extras</h2>
            </div>
            <div class="flex justify-between items-center mb-4" v-show="extras.levels?.length > 0">
                <div class="flex flex-wrap gap-4">
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-green-500 rounded"></div>
                        <span>{{ displayLevels.extras[0] }}</span>
                    </div>
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-orange-400 rounded"></div>
                        <span>{{ displayLevels.extras[1] }}</span>
                    </div>
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-red-500 rounded"></div>
                        <span>{{ displayLevels.extras[2] }}</span>
                    </div>
                </div>
            </div>

            <!-- Table 2 -->
            <DataTable
                :value="displayExtras"
                stripedRows
                showGridlines
                tableStyle="min-width: 30rem"
                class="min-w-full extras-table"
                scrollable
                scrollHeight="525px"
                v-show="extras.data?.length > 0">
                <Column field="client" header="Cliente">
                    <template #body="{data}">
                        <span
                            :class="{'green-cell': data.level === 0,
                                'orange-cell': data.level === 1,
                                'red-cell': data.level === 2}">
                            {{ data.client }}
                        </span>
                    </template>
                </Column>
                <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header">
                    <template #body="{data, field}">
                        <span>
                            {{ data[field] }}
                        </span>
                    </template>
                </Column>
            </DataTable>
            <div class="flex items-center ml-2 mt-4" v-show="globals.data?.length > 0">
                <h2>Total Global</h2>
            </div>
            <div class="flex justify-between items-center mb-4" v-show="globals.levels?.length > 0">
                <div class="flex flex-wrap gap-4">
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-green-500 rounded"></div>
                        <span>{{ displayLevels.globals[0] }}</span>
                    </div>
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-orange-400 rounded"></div>
                        <span>{{ displayLevels.globals[1] }}</span>
                    </div>
                    <div class="flex gap-2 items-center">
                        <div class="w-4 h-4 bg-red-500 rounded"></div>
                        <span>{{ displayLevels.globals[2] }}</span>
                    </div>
                </div>
            </div>

            <!-- Table 3 -->
            <DataTable
                :value="displayGlobals"
                stripedRows
                showGridlines
                tableStyle="min-width: 30rem"
                class="min-w-full globals-table"
                scrollable
                scrollHeight="525px"
                v-show="globals.data?.length > 0">
                <Column field="client" header="Cliente">
                    <template #body="{data}">
                        <span
                            :class="{'green-cell': data.level === 0,
                                'orange-cell': data.level === 1,
                                'red-cell': data.level === 2}">
                            {{ data.client }}
                        </span>
                    </template>
                </Column>
                <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header">
                    <template #body="{data, field}">
                        <span>
                            {{ data[field] }}
                        </span>
                    </template>
                </Column>
            </DataTable>
        </div>
    </section>
</template>

<script>
    import axiosInstance from '../axiosInstance';

    export default {
        data() {
            return {
                years: [],
                selectedYear: {},
                reports: [],
                selectedReport: {},
                companies: [],
                selectedCompany: {},
                selectedBranch: {},
                formDisabled: false,
                buttonDisabled: false,
                months: {
                    0: "january",
                    1: "february",
                    2: "march",
                    3: "april",
                    4: "may",
                    5: "june",
                    6: "july",
                    7: "august",
                    8: "september",
                    9: "october",
                    10: "november",
                    11: "december"
                },

                columns:[
                    { field: "january", header: "Enero"},
                    { field: "february", header: "Febrero"},
                    { field: "march", header: "Marzo"},
                    { field: "april", header: "Abril"},
                    { field: "may", header: "Mayo"},
                    { field: "june", header: "Junio"},
                    { field: "july", header: "Julio"},
                    { field: "august", header: "Agosto"},
                    { field: "september", header: "Septiembre"},
                    { field: "october", header: "Octubre"},
                    { field: "november", header: "Noviembre"},
                    { field: "december", header: "Diciembre"},
                    { field: "total", header: "Total"}
                ],
                accounts: {data: [], levels: []},
                extras: {data: [], levels: []},
                globals: {data: [], levels: []},
                sortBy: null, // 'color', 'total', 'name'
                title: "",
                showSortPanel: false,
                ivaOption: 'with', // 'with' or 'without'
                ivaOptions: [
                    { label: 'Con IVA', value: 'with' },
                    { label: 'Sin IVA', value: 'without' }
                ],
                IVA_RATE: 0.16 // 16% IVA
            }
        },

        computed: {
            /**
             * Returns accounts data with or without IVA based on selected option
             */
            displayAccounts() {
                return this.applyIvaToData(this.accounts.data);
            },

            /**
             * Returns extras data with or without IVA based on selected option
             */
            displayExtras() {
                return this.applyIvaToData(this.extras.data);
            },

            /**
             * Returns globals data with or without IVA based on selected option
             */
            displayGlobals() {
                return this.applyIvaToData(this.globals.data);
            },

            /**
             * Returns level thresholds with or without IVA
             */
            displayLevels() {
                return {
                    accounts: this.applyIvaToLevels(this.accounts.levels),
                    extras: this.applyIvaToLevels(this.extras.levels),
                    globals: this.applyIvaToLevels(this.globals.levels)
                };
            }
        },

        methods: {
            /**
             * Fetch initial data for accounts viewer (companies, default selections, years, reports)
             */
            async fetchAccountsViewerInitialData() {
                this.$emit("update-loading", true);
                this.formDisabled = true;
                this.buttonDisabled = true;
                let data = {};
                try {
                    const response = axiosInstance.post("/api/client_finances", {
                        token: localStorage.getItem('token')
                    });

                    data = await response;
            
                } catch(error) {
                    console.error("fetchAccountsViewerInitialData: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                }

                return data;
            },

            /**
             * Set initial data for the component (companies, branches, years, reports, default selections)
             */

            setInitialData() {
                this.fetchAccountsViewerInitialData().then((response) => {
                    if(response.status === 200){
                        const { defaultCmp, companies, reports, years } = response.data;

                        this.years = years.map((year) => {
                            return { name: year, value: year }
                        });
                        this.selectedYear = this.years[0];

                        this.companies = companies.map((company) => {
                            return {
                                name: company.data.name,
                                id: company.data.id,
                                branches: company.branches
                            }
                        });

                        this.selectedCompany = {
                            name: defaultCmp.data.name, 
                            id: defaultCmp.data.id, 
                            branches: defaultCmp.branches
                        }

                        this.reports = reports;
                        this.selectedReport = this.reports[0];

                        this.selectedBranch = this.selectedCompany.branches[0];
                        this.formDisabled = false;
                        this.buttonDisabled = false;
                    } else {
                        console.warn("setInitialData: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            },

            /**
             * Fetch accounts data based on selected filters (year, report, company, branch)
             */
            async fetchAccountsData() {
                this.$emit("update-loading", true);
                this.buttonDisabled = true;
                let data = {};
                try {
                    const response = axiosInstance.post("/api/client_finances_data", {
                        token: localStorage.getItem('token'),
                        year: this.selectedYear.value,
                        report: this.selectedReport.id,
                        company_id: this.selectedCompany.id,
                        branch_id: this.selectedBranch.id
                    });

                    data = await response;
            
                } catch(error) {
                    console.error("fetchAccountsData: There was an error!", error);
                    this.$toast.add({ severity: 'error', summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', life: 5000, group: 'topr' });
                } finally {
                    this.$emit("update-loading", false);
                    this.buttonDisabled = false;
                }

                return data;
            },

            /**
             * Fill accounts, extras, and globals tables with fetched data
             */
            fillTable() {
                this.fetchAccountsData().then((response) => {
                    if(response.status == 200) {
                        this.accounts.data = {data: [], levels: []};
                        this.extras.data = {data: [], levels: []};
                        this.globals.data = {data: [], levels: []};
                        this.showSortPanel = false;

                        const { year, title, debtButtons } = response.data;

                        Object.values(response.data.data).map((element) => {
                            const clientsData = Object.values(element.data.clients).map((client) => {
                                let clientMonths = {};
                                client.months.forEach((month, index) => {
                                    clientMonths[this.months[index]] = month;
                                });
                                return {
                                    client: client.name,
                                    level: client.level,
                                    ...clientMonths,
                                    total: client.total
                                }
                            })

                            let totalsMonths = {};
                            element.data.totals.months.forEach((month, index) => {
                                totalsMonths[this.months[index]] = month;
                            });

                            const totals = {
                                client: element.data.totals.name,
                                level: element.data.totals.level,
                                total: element.data.totals.total,
                                ...totalsMonths
                            };

                            clientsData.push(totals);
                            
                            if(element.label === 'Iguala mensual') {
                                this.accounts.data = clientsData;
                                this.accounts.levels = element.data.levels ? element.data.levels : [];
                            }

                            if (element.label === 'Servicios extras') {
                                this.extras.data = clientsData;
                                this.extras.levels = element.data.levels ? element.data.levels : [];
                            }

                            if (element.label === 'Total Global') {
                                this.globals.data = clientsData;
                                this.globals.levels = element.data.levels ? element.data.levels : [];
                            }
                        })

                        this.showSortPanel = debtButtons;

                        this.title = `${title} ${year}`;

                        this.sortAccounts("color");
                    } else {
                        console.warn("fillTable: There was a problem with the request.", response);
                        this.$toast.add({ severity: 'warn', summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', life: 5000, group: 'topr' });
                    }
                })
            },
            /**
             * 
             * @param criterion - 'color', 'total', 'name'
             */
            sortAccounts(criterion) {
                if (this.accounts.data?.length < 2) return;

                const accountsWithoutTotals = this.accounts.data?.slice(0, -1);
                const totals = this.accounts.data[this.accounts.data?.length - 1];

                let sorted = [...accountsWithoutTotals];
                if (criterion === 'color') {
                    sorted.sort((a, b) => (b.level ?? 0) - (a.level ?? 0));
                } else if (criterion === 'total') {
                    sorted.sort((a, b) => {
                        const aNum = parseFloat((a.total || '0').toString().replace(/,/g, ''));
                        const bNum = parseFloat((b.total || '0').toString().replace(/,/g, ''));
                        return bNum - aNum;
                    });
                } else if (criterion === 'name') {
                    sorted.sort((a, b) => a.client.localeCompare(b.client));
                }

                this.accounts.data = [...sorted, totals];
            },

            /**
             * 
             * @param criterion - 'color', 'total', 'name'
             */

            sortExtras(criterion) {
                if (this.extras.data?.length < 2) return;

                const extrasWithoutTotals = this.extras.data?.slice(0, -1);
                const totals = this.extras.data[this.extras.data?.length - 1];

                let sorted = [...extrasWithoutTotals];
                if (criterion === 'color') {
                    sorted.sort((a, b) => (b.level ?? 0) - (a.level ?? 0));
                } else if (criterion === 'total') {
                    sorted.sort((a, b) => {
                        const aNum = parseFloat((a.total || '0').toString().replace(/,/g, ''));
                        const bNum = parseFloat((b.total || '0').toString().replace(/,/g, ''));
                        return bNum - aNum;
                    });
                } else if (criterion === 'name') {
                    sorted.sort((a, b) => a.client.trim().localeCompare(b.client.trim()));
                }

                this.extras.data = [...sorted, totals];
            },

            /**
             * 
             * @param criterion - 'color', 'total', 'name'
             */
            sortTables(criterion){
                this.sortBy = criterion;
                this.sortAccounts(criterion);
                this.sortExtras(criterion);
            },

            companyChange() {
                this.selectedBranch = this.selectedCompany.branches[0];
            },

            /**
             * Handler for IVA dropdown change
             */
            onIvaChange() {
                // Force re-render by triggering computed properties
                // No additional action needed as computed properties handle the transformation
            },

            /**
             * Removes IVA from a numeric string value
             * @param {string} value - The value with IVA (e.g., "1,160.00")
             * @returns {string} - The value without IVA, formatted (e.g., "1,000.00")
             */
            removeIva(value) {
                if (!value || value === "" || value === "0.00") return value;
                
                // Remove commas and parse to number
                const numValue = parseFloat(value.toString().replace(/,/g, ''));
                
                if (isNaN(numValue)) return value;
                
                // Calculate value without IVA: value / (1 + IVA_RATE)
                const valueWithoutIva = numValue / (1 + this.IVA_RATE);
                
                // Format back to string with commas
                return this.formatCurrency(valueWithoutIva);
            },

            /**
             * Formats a number as currency string with commas
             * @param {number} value - The numeric value
             * @returns {string} - Formatted string (e.g., "1,000.00")
             */
            formatCurrency(value) {
                return value.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            },

            /**
             * Applies IVA transformation to a dataset based on current IVA option
             * @param {Array} data - Array of data objects with month values and totals
             * @returns {Array} - Transformed data array
             */
            applyIvaToData(data) {
                if (!Array.isArray(data) || data.length === 0) return data;
                if (this.ivaOption === 'with') return data;

                // Create a deep copy and remove IVA from all monetary values
                return data.map(row => {
                    const newRow = { ...row };
                    
                    // Transform all month fields
                    Object.keys(this.months).forEach(key => {
                        const monthName = this.months[key];
                        if (newRow[monthName]) {
                            newRow[monthName] = this.removeIva(newRow[monthName]);
                        }
                    });
                    
                    // Transform total
                    if (newRow.total) {
                        newRow.total = this.removeIva(newRow.total);
                    }
                    
                    return newRow;
                });
            },

            /**
             * Applies IVA transformation to level thresholds
             * @param {Array} levels - Array of level threshold strings
             * @returns {Array} - Transformed level array
             */
            applyIvaToLevels(levels) {
                if (!Array.isArray(levels) || levels.length === 0) return levels;
                if (this.ivaOption === 'with') return levels;

                return levels.map(level => this.removeIva(level));
            }
        },

        mounted() {
            this.setInitialData();
        }
    }
</script>

<style scoped>
::v-deep(.p-datatable) {
    border-radius: 0.5rem !important;
    overflow: hidden !important;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1) !important;
}

::v-deep(.p-datatable tbody tr td) {
    text-align: right !important;
}

/* Tabla 1 - accounts-table */
::v-deep(.accounts-table.p-datatable .p-datatable-thead > tr > th) {
    background-color: #0f1338 !important;
    color: white !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(odd) > td) {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(even) > td) {
    background-color: #ffffff !important;
    color: #111827 !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr > td:first-child) {
    text-align: left !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.green-cell)) {
    /* background-color: #dcfce7 !important; */
    color: #166534 !important;
    font-weight: 600 !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.orange-cell)) {
    /* background-color: #fed7aa !important; */
    color: #d66400 !important;
    font-weight: 600 !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.red-cell)) {
    /* background-color: #fecaca !important; */
    color: #ab0000 !important;
    font-weight: 600 !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr:last-child > td) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600 !important;
}

::v-deep(.accounts-table.p-datatable .p-datatable-tbody > tr:last-child > td:first-child) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600 !important;
    text-align: left !important;
}

/* Tabla 2 - extras-table */
::v-deep(.extras-table.p-datatable .p-datatable-thead > tr > th) {
    background-color: #0f1338 !important;
    color: white !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(odd) > td) {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(even) > td) {
    background-color: #ffffff !important;
    color: #111827 !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr > td:first-child) {
    text-align: left !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.green-cell)) {
    /* background-color: #dcfce7 !important; */
    color: #166534 !important;
    font-weight: 600 !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.orange-cell)) {
    /* background-color: #fed7aa !important; */
    color: #d66400 !important;
    font-weight: 600 !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.red-cell)) {
    /* background-color: #fecaca !important; */
    color: #ab0000 !important;
    font-weight: 600 !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr:last-child > td) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600 !important;
}

::v-deep(.extras-table.p-datatable .p-datatable-tbody > tr:last-child > td:first-child) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600 !important;
    text-align: left !important;
}

/* Tabla 3 - globals-table */
::v-deep(.globals-table.p-datatable .p-datatable-thead > tr > th) {
    background-color: #0f1338 !important;
    color: white !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(odd) > td) {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(even) > td) {
    background-color: #ffffff !important;
    color: #111827 !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr > td:first-child) {
    text-align: left !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.green-cell)) {
    /* background-color: #dcfce7 !important; */
    color: #166534 !important;
    font-weight: 600 !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.orange-cell)) {
    /* background-color: #fed7aa !important; */
    color: #d66400 !important;
    font-weight: 600 !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.red-cell)) {
    /* background-color: #fecaca !important; */
    color: #ab0000 !important;
    font-weight: 600 !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr:last-child > td) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600 !important;
}

::v-deep(.globals-table.p-datatable .p-datatable-tbody > tr:last-child > td:first-child) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600 !important;
    text-align: left !important;
}

#show-btn {
    @apply bg-zinc-200 text-zinc-900 border border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 rounded px-4 py-2 text-lg shadow focus:outline-none transition-colors;
}

Button.order-table-btn {
    @apply bg-zinc-200 text-zinc-900 border-zinc-300 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-100 dark:border-zinc-600 dark:hover:bg-zinc-600 transition-colors;
}
</style>

<style>
/* Modo oscuro - Tabla 1 */
.dark .accounts-table.p-datatable .p-datatable-thead > tr > th {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr > td {
    color: white !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(odd) > td {
    background-color: #18181b !important;
    color: white !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(even) > td {
    background-color: #27272a !important;
    color: white !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.green-cell) {
    /* background-color: #166534 !important; */
    color: #9bffbe !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.orange-cell) {
    /* background-color: #9a3412 !important; */
    color: #ffc17b !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.red-cell) {
    /* background-color: #991b1b !important; */
    color: #ff7070 !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr:last-child > td {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .accounts-table.p-datatable .p-datatable-tbody > tr:last-child > td:first-child {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

/* Modo oscuro - Tabla 2 */
.dark .extras-table.p-datatable .p-datatable-thead > tr > th {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr > td {
    color: white !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(odd) > td {
    background-color: #18181b !important;
    color: white !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(even) > td {
    background-color: #27272a !important;
    color: white !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.green-cell) {
    /* background-color: #166534 !important; */
    color: #9bffbe !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.orange-cell) {
    /* background-color: #9a3412 !important; */
    color: #ffc17b !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.red-cell) {
    /* background-color: #991b1b !important; */
    color: #ff7070 !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr:last-child > td {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .extras-table.p-datatable .p-datatable-tbody > tr:last-child > td:first-child {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

/* Modo oscuro - Tabla 3 */
.dark .globals-table.p-datatable .p-datatable-thead > tr > th {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr > td {
    color: white !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(odd) > td {
    background-color: #18181b !important;
    color: white !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child):nth-child(even) > td {
    background-color: #27272a !important;
    color: white !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.green-cell) {
    /* background-color: #166534 !important; */
    color: #9bffbe !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.orange-cell) {
    /* background-color: #9a3412 !important; */
    color: #ffc17b !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr:not(:last-child) > td:first-child:has(.red-cell) {
    /* background-color: #991b1b !important; */
    color: #ff7070 !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr:last-child > td {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .globals-table.p-datatable .p-datatable-tbody > tr:last-child > td:first-child {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}
</style>